import { makeStyles } from '@material-ui/core'
import { pallete } from '@themes/colors/squids'

const useStyles = makeStyles((theme) => ({
  card: {
    display: 'flex',
    padding: '8px 16px 8px 16px',
    flexDirection: 'column',
    width: 320,
    height: 140,
    margin: theme.spacing(2),
    [theme.breakpoints.down('sm')]: {
      width: '100%',
      height: 200,
      padding: '8px 16px 8px 16px',
    },
  },
  row: {
    display: 'flex',
    flex: 1,
    alignItems: 'center',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
    },
  },
  padding: {
    padding: 16,
  },
  col: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    height: '100%',
    justifyContent: 'space-between',
    [theme.breakpoints.down('sm')]: {
      alignItems: 'flex-start',
    },
  },
  title: {
    fontSize: 20,
    fontWeight: 'bold',
    color: theme.palette.primary.main,
  },
  price: {
    fontSize: 20,
    fontWeight: 'bold',
  },
  description: {
    fontSize: 16,
    color: 'black',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: '2',
    WebkitBoxOrient: 'vertical',
  },
  button: {
    color: 'white',
    width: 80,
    height: 35,
    alignSelf: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      margin: '10px 0px 10px 0px',
      width: '100%',
    },
  },
  txPremium: {
    color: theme.palette.primary.main,
  },
  bgPremium: {
    backgroundColor: pallete.lightGreen,
  },
  txDetails: {
    fontSize: 16,
    [theme.breakpoints.down('sm')]: {
      fontSize: 12,
      margin: '4px 0px 4px 0px',
    },
  },
}))

export default useStyles
